import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommBrandAppleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.9124 2C16.0386 3.17077 15.5746 4.34683 14.8896 5.1932 14.2023 6.03795 13.0777 6.6961 11.975 6.60911 11.826 5.45947 12.382 4.26472 13.0178 3.51428 13.7274 2.66872 14.924 2.04065 15.9124 2zM19.4694 8.82782C19.2575 8.96232 17.3398 10.1794 17.3637 12.6276 17.3899 15.5832 19.854 16.6115 19.994 16.6699 19.9973 16.6713 20 16.6725 20 16.6725 19.9987 16.6764 19.9962 16.6845 19.9925 16.6965 19.9308 16.8966 19.5329 18.1871 18.6389 19.5173 17.8202 20.736 16.9715 21.9483 15.6328 21.9731 14.9893 21.9856 14.5594 21.7962 14.1123 21.5993 13.6446 21.3934 13.1581 21.1791 12.3887 21.1791 11.5825 21.1791 11.0733 21.4 10.583 21.6128 10.1581 21.7972 9.74725 21.9755 9.16938 21.9987 7.8778 22.0487 6.89335 20.6828 6.06784 19.4689 4.37929 16.9855 3.08971 12.4508 4.82259 9.3909 5.68125 7.87052 7.21924 6.90788 8.88782 6.88268 9.60665 6.86977 10.3032 7.15128 10.9127 7.39765 11.3788 7.58602 11.794 7.75385 12.1295 7.75385 12.431 7.75385 12.8351 7.59161 13.3062 7.40244 14.0481 7.10461 14.9562 6.74003 15.8916 6.83674 16.5318 6.86357 18.3306 7.09935 19.4852 8.81771 19.4821 8.81977 19.4768 8.82314 19.4694 8.82782z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
